import React, { useEffect, useRef } from 'react';
import { AnalyticsParamValues } from 'constants/analytics';
import Benefit from 'containers/shared/benefit/benefit';
import NotFound from 'containers/shared/not_found/notFound';
import Loader from 'components/common/loader';

export const HotYoterBenefitsResults = ({
    benefits = [],
    metadata = {},
    translations = {},
    loadingMore = false,
    onLoadMore = null,
    testID = 'hot-yoter-benefits-results',
}) => {
    const analyticsSource = AnalyticsParamValues.CATEGORY_PAGE_SOURCE;
    const shouldGetMoreRef = useRef(true);

    useEffect(() => {
        shouldGetMoreRef.current = true;
    }, [benefits, metadata?.currentPage]);

    useEffect(() => {
        if (!onLoadMore) {
            return undefined;
        }

        const handleScroll = () => {
            const resultsContainer = document.querySelector(
                `[testId="${testID}"] .benefits-grid:last-of-type`,
            );

            if (!resultsContainer || !shouldGetMoreRef.current) {
                return;
            }

            const isBottom = resultsContainer.getBoundingClientRect().bottom <= window.innerHeight;
            const areThereMoreResults = metadata?.totalLeftPages > 0;

            if (isBottom && areThereMoreResults && !loadingMore) {
                shouldGetMoreRef.current = false;
                onLoadMore();
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, [benefits, metadata, loadingMore, onLoadMore, testID]);

    if (benefits.length === 0) {
        return <NotFound />;
    }

    const promotedData = benefits.filter((benefit) => benefit.is_promoted);
    const regularData = benefits.filter((benefit) => !benefit.is_promoted);
    const hasPromoted = promotedData.length > 0;

    return (
        <div testId={testID}>
            {hasPromoted ? (
                <div className="benefits-grid benefits-grid_promoted">
                    {promotedData.map((benefit) => (
                        <Benefit
                            key={benefit.id}
                            data={benefit}
                            analyticsSource={analyticsSource}
                        />
                    ))}
                </div>
            ) : null}

            {hasPromoted && regularData.length > 0 ? (
                <h3 className="regular-benefits-title">
                    {translations.regular_benefits_see_more_title
                        ?? translations['regular_benefits_see_more_title']}
                </h3>
            ) : null}

            {regularData.length > 0 ? (
                <div className={`benefits-grid ${hasPromoted ? 'benefits-grid_regular' : 'benefits-grid_promoted'}`}>
                    {regularData.map((benefit) => (
                        <Benefit
                            key={benefit.id}
                            data={benefit}
                            analyticsSource={analyticsSource}
                            smallVersion={hasPromoted}
                        />
                    ))}
                </div>
            ) : null}

            {loadingMore ? <Loader className="benefits-loader" /> : null}
        </div>
    );
};
